import React from "react";
import Users from "../components/Settings/Users";


export default function Settings() {
  return <Users density="standard" />;
}
